/**
 * OtherInfo
 * 
 * @Author: Focci
 * @Date: 2023-08-20 13:59:56
 * @Last Modified by: Focci
 * @Last Modified time: 2023-08-20 13:59:56
 */

'use client'

import PropTypes from 'prop-types'
import { useLocale, useTranslations } from 'next-intl'
import { formatDate } from '@lib/datetime'

export default function OtherInfo({
  isSoldOrEstimate,
  house = {}
}) {
  const lang = useLocale()
  const th = useTranslations('house')
  const updateAtLabel = /\d+/.test(house.updateAt) 
    ? formatDate(parseFloat(house.updateAt), 'YYYY-MM-DD HH:mm:ss', lang)
    : '-'

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-3 mt-6 text-f.8">
      {!isSoldOrEstimate && (
        <span>
          <span className="text-meta">{`${th('propertyCode')}：`}</span>
          {house.code}
        </span>
      )}
      <span>
        <span className="text-meta">{`${th('lastUpdateTime')}：`}</span>
        {updateAtLabel}
      </span>
    </div>
  )
}

OtherInfo.propTypes = {
  house: PropTypes.object,
}
